function ClientLibraryHref({
  job,
  roleType,
}) {
  if (roleType === "area_director") {
    return `?view=reuse_job&job=${job.id}`;
  }

  return `client_library/${job.id}?type=${job.model_name}`;
}

export default ClientLibraryHref;
